import React from "react";
import { Redirect } from "react-router-dom";

export default function LaunchToTimers() {
  return <Redirect to="/db/timetracking/timers" />;
}
